import type { UniformConfigurationItem } from "~types/uniformConfigurationItem";
import type { UniformItem } from "~types/uniformItem";
import type { FormColors, FormType } from "../models/formModel";

export const transformUniformItemsResponse = (
  uniformItemTypes: UniformConfigurationItem[],
  uniformItemsResponse?: UniformItem[],
): FormType["uniformParts"] =>
  uniformItemTypes
    .flatMap((x) => x.itemTypes)
    .reduce<FormType["uniformParts"]>((acc, item) => {
      Object.entries(item).forEach((entry) => {
        const [itemType, colors] = entry;
        const responseItem = uniformItemsResponse?.find((x) => x.itemType === itemType);
        acc[itemType] = {
          uniformItemId: responseItem?.uniformItemId ?? "",
          nameLatin: responseItem?.nameLatin ?? "",
          nameLocal: responseItem?.nameLocal ?? "",
          colors: colors.reduce<FormColors>((acc, color) => {
            acc[color] = responseItem?.colors[color];
            return acc;
          }, {}),
        };
      });
      return acc;
    }, {});
